import { Link } from 'react-router-dom';

export default function InvalidCategoryNotice() {
  return (
    <section className="relative pt-32 pb-24 md:pt-44 md:pb-32 bg-[#faf8f5]">
      <div className="w-full px-6 md:px-12 lg:px-20 flex flex-col items-center text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#f0ebe2] mb-6">
          <i className="ri-question-line text-[#b08060] text-3xl"></i>
        </div>
        <p className="text-[0.8125rem] tracking-[0.2em] text-[#b08060] font-medium uppercase mb-3">
          鳴箏筆記・分類
        </p>
        <h1
          className="font-serif-tc text-[#2c2420] leading-[1.3] mb-4"
          style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}
        >
          找不到這個文章分類
        </h1>
        <p className="text-[1.0625rem] leading-[1.8] text-[#7a6e62] mb-9 max-w-md">
          你開啟的分類連結可能已失效，或分類名稱有誤。
          <br />
          別擔心，回到全部文章就可以繼續瀏覽。
        </p>
        <Link
          to="/notes"
          className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#5a3e22] text-white text-[0.9375rem] font-medium hover:bg-[#7a6248] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回全部文章
        </Link>
      </div>
    </section>
  );
}